module.exports = __webpack_public_path__ + "themify.ttf?e23a7dcaefbde4e74e263247aa42ecd7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/themify.ttf?-fvbane
// module id = 924
// module chunks = 27